module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("SEEING THE UNSEEN")]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Our purpose at Howard Books is to:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('em', [_vm._v("Increase faith")]), _vm._v(" in the hearts of growing Christians")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Inspire holiness")]), _vm._v(" in the lives of believers")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Instill hope")]), _vm._v(" in the hearts of struggling people everywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Because He’s coming again!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img02_1-5.png"
    }
  })])]), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("SEEING THE UNSEEN")])]), _c('a', {
    attrs: {
      "id": "title"
    }
  }, [_c('p', {
    staticClass: "bauthor"
  }, [_vm._v("JOE BEAM")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("Howard Books"), _c('br'), _vm._v("New York London Toronto Sydney")])]), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "title"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Published by Howard Books, a division of Simon & Schuster, Inc."), _c('br'), _vm._v("1230 Avenue of the Americas, New York, NY 10020"), _c('br')]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")]), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.howardpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.howardpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Seeing the Unseen Revised © 2000 by Joe Beam")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information, address Permission Department, Simon & Schuster, 1230 Avenue of the Americas, New York, NY 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Beam, Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seeing the unseen : preparing yourself for spiritual warfare / Joe Beam.—Rev. and updated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN 1-58229-273-6 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("eISBN-13: 978-1-43912-272-3"), _c('br'), _vm._v("ISBN: 978-1-58229-273-1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Spiritual warfare. 2. Devil. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("BV4509.5 .B43 2000")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("235′.4—dc21   00-061367")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("20  19  18  17  16  15  14  13  12")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("HOWARD is a registered trademark of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For information regarding special discounts for bulk purchases, please contact: Simon & Schuster Special Sales at 1-800-456-6798 or business@simonandschuster.com.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Interior design by Stephanie Denney")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Edited by Philis Boultinghouse")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Scripture quotations not otherwise marked are from the Holy Bible, New International Version. Copyright © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan Bible Publishers. Other Scriptures are quoted from the American Standard Edition of the Revised Version ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASV")]), _vm._v("), © 1929 by International Council of Religious Education; The Holy Bible, New King James Version ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v("), © 1992 by Thomas Nelson, Inc.; New American Standard Bible ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v("), © 1973 by The Lockman Foundation; and The Holy Bible, Authorized King James Version ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("KJV")]), _vm._v("), © 1961 by the National Publishing Co. Italics in scriptures were added by the author for emphasis."), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("For my wife, Alice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If it had not been for her unquenchable love, I surely would have lost my spiritual war.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img03_1-6.png"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img04_1-7.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("2 Corinthians 10:3-5")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("For though we live in the world, we do not wage war as the world does. The weapons we fight with are not the weapons of the world. On the contrary, they have divine power to demolish strongholds. We demolish arguments and every pretension that sets itself up against the knowledge of God, and we take captive every thought to make it obedient to Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img04_1-7.png"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "cont"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img04_1-7.png"
    }
  })])]), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#pt01"
    }
  }, [_c('strong', [_vm._v("SECTION 1. LEARNING TO SEE THE UNSEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1. What Is Spiritual Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2. What is Satan’s Master Strategy for Destruction?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_vm._v("3. What are Angels?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION 2: FORCES AT WORK AGAINST US")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Is There Really a Devil?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Where Did Satan Come from, and Where Is He Now?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. What Power Does Satan Have?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. What Do Satan’s Angels Do?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. What are Demons?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Can Demons Still Possess People?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. How Do Christians Overcome the Demonic Today?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Are Some Humans Empowered by Satan?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION 3: FORCES AT WORK WITHIN US")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Why Do Christians Sin?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. How Can Pleasure Be Bad?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. How Does Satan Use Pain?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. How Does Satan Religion?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. How Does Satan Use Families against Themselves?")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04#pt04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION 4: FORCES AT WORK FOR US")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Why Does God Let Satan Hurt Us?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. How Does the Cross Defeat Satan?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Why Does the Holy Spirit Live in Me?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Are Good Angels Active in My Life?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. How Do Gods People—Living and Dead—Help Us?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. How Does Faith Give the Victory?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/discussion#disque",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-276a1a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontm.vue
// module id = 63
// module chunks = 0